export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9380.e00bbc3b.jpg";